var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/MobileHeader.js",
  _this = this;
import React from 'react';
import Grid from '../Grid';
import Row from '../Row';
import Column from '../Column';
import Text from '../Text';
import Logo from './Logo';
import IconMenu from './IconMenu';
import { Filter as IconHamburger } from '@dls/assets/icons';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { remCalc } from '@lux/helpers';
var SCHeaderMobile = withTheme(styled.div.withConfig({
  displayName: "MobileHeader__SCHeaderMobile",
  componentId: "sc-1fqu38k-0"
})(function (props) {
  return css(["display:block;width:100%;@media (min-width:", "){display:none;}"], props.coreTheme.brk_md);
}));
var SCLogoColumn = styled(Column).withConfig({
  displayName: "MobileHeader__SCLogoColumn",
  componentId: "sc-1fqu38k-1"
})(["display:flex !important;align-items:", ";"], function (props) {
  return props.showHamburgerRight ? 'flex-start' : 'center';
});
var SCRightHandColumn = styled.div.withConfig({
  displayName: "MobileHeader__SCRightHandColumn",
  componentId: "sc-1fqu38k-2"
})(["display:flex;align-items:center;float:right;"]);
var SCHamburgerAnchor = withTheme(styled(Text).withConfig({
  displayName: "MobileHeader__SCHamburgerAnchor",
  componentId: "sc-1fqu38k-3"
})(function (props) {
  return css(["display:block;height:", ";width:", ";float:", ";svg{height:", ";width:", ";}"], remCalc(22), remCalc(22), props.iconRight ? 'right' : 'left', props.coreTheme.header.mobileIconHeight, props.coreTheme.header.mobileIconWidth);
}));
var SCIconHamburger = styled.img.withConfig({
  displayName: "MobileHeader__SCIconHamburger",
  componentId: "sc-1fqu38k-4"
})(["height:100%;width:100%;"]);
var SCHamburgerIcon = styled(IconHamburger).withConfig({
  displayName: "MobileHeader__SCHamburgerIcon",
  componentId: "sc-1fqu38k-5"
})(["cursor:pointer;"]);
var HamburgerMenu = function HamburgerMenu(_ref) {
  var Src = _ref.src,
    onClick = _ref.onClick,
    _ref$iconRight = _ref.iconRight,
    iconRight = _ref$iconRight === void 0 ? false : _ref$iconRight;
  return /*#__PURE__*/React.createElement(SCHamburgerAnchor, {
    type: "link",
    iconRight: iconRight,
    onClick: onClick,
    "data-testid": "hamburger-menu",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 3
    }
  }, Src ? typeof Src === 'string' ? /*#__PURE__*/React.createElement(SCIconHamburger, {
    src: Src,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(Src, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(SCHamburgerIcon, {
    size: 22,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 7
    }
  }));
};
var MobileRHSControls = function MobileRHSControls(_ref2) {
  var baseUrl = _ref2.baseUrl,
    menuIcons = _ref2.menuIcons;
  return /*#__PURE__*/React.createElement(React.Fragment, null, menuIcons.map(function (menuIcon, key) {
    return /*#__PURE__*/React.createElement(IconMenu, {
      baseUrl: baseUrl,
      icon: menuIcon.icon,
      subMenu: menuIcon.subMenu,
      key: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 9
      }
    });
  }));
};
var MobileHeader = function MobileHeader(_ref3) {
  var baseUrl = _ref3.baseUrl,
    logo = _ref3.logo,
    menuIcons = _ref3.menuIcons,
    onHamburgerClick = _ref3.onHamburgerClick,
    showHamburger = _ref3.showHamburger,
    showHamburgerRight = _ref3.showHamburgerRight,
    hamburgerOpenIcon = _ref3.hamburgerOpenIcon;
  return /*#__PURE__*/React.createElement(SCHeaderMobile, {
    "data-testid": "mobile-header",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Row, {
    middle: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 7
    }
  }, showHamburger && !showHamburgerRight && /*#__PURE__*/React.createElement(Column, {
    xs: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 110,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(HamburgerMenu, {
    src: hamburgerOpenIcon,
    onClick: onHamburgerClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(SCLogoColumn, {
    showHamburgerRight: showHamburgerRight,
    xs: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 9
    }
  }, logo && /*#__PURE__*/React.createElement(Logo, {
    baseUrl: baseUrl,
    href: logo.href,
    alt: logo.alt,
    src: logo.src,
    mode: "mobile",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Column, {
    xs: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SCRightHandColumn, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 11
    }
  }, menuIcons && /*#__PURE__*/React.createElement(MobileRHSControls, {
    baseUrl: baseUrl,
    menuIcons: menuIcons,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 15
    }
  }))), showHamburger && showHamburgerRight && /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(HamburgerMenu, {
    xs: 3,
    src: hamburgerOpenIcon,
    onClick: onHamburgerClick,
    iconRight: showHamburgerRight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 13
    }
  })))));
};
export default MobileHeader;